










import { Component, Watch, Vue } from "vue-property-decorator";
import Axios from "axios";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters({
      userLocale: "user/locale"
    })
  }
})
export default class DocsIcon extends Vue {
  // Data
  public userLocale!: string;
  public hasDocsFile = false;
  public data: any = {};

  public created() {
    if (this.docsPath) this.loadDocs();
  }

  // Wathers
  @Watch("docsPath")
  public onDocsPathChange() {
    if (this.docsPath) this.loadDocs();
  }

  // Getters
  public get docsPath() {
    // Exact match
    return this.$_.get(this.$route, "meta.docs");

    // Fallback to the nearest parent docs
    // const matched = this.$_.clone(this.$route.matched);
    // return this.$_.get(
    //   this.$_.find(this.$_.reverse(matched), i => i.meta.docs),
    //   "meta.docs"
    // );
  }

  // Methods
  public loadDocs() {
    // Get docs for current locale
    return Axios.get(`${this.docsPath}/${this.userLocale}.md`)
      .then(response => {
        this.data = response.data;
        this.hasDocsFile = true;
      })
      .catch(() => {
        // Docs not found
        this.hasDocsFile = false;
      });
  }
  public openDocsPreviwModal() {
    this.$store.dispatch("ui/openDocsPreviewModal", {
      props: {
        text: this.data
      }
    });
  }
}
